module.exports = __webpack_public_path__ + "6bfc81b531afac0cac91ad2826c0ef80.svg";